import React from 'react';
import ReportingMarketingMetaAdsPage from '../components/ReportingMarketingMetaAdsPage';

const axios = require('axios').default;

const ReportingMarketingMetaAdsApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingMarketingMetaAdsPage {...props} />;
};

export default ReportingMarketingMetaAdsApp;
